export default {
  LAUNCHER: {
    ADDRESS: 'Address',
    PRODUCT_CATALOG_SALES: 'PRODUCT_CATALOG_SALES',
    CONVERSIONS: 'CONVERSIONS',
    LINK_CLICKS: 'LINK_CLICKS',
    CONVERSIONS_VALUE: 'Conversions',
    DAA: 'DAA',
    COLLECTION: 'Collection',
    FACEBOOK: 'facebook',
    INSTAGRAM: 'instagram',
    AUDIENCENETWORK: 'audience_network',
    MESSENGER: 'messenger',
    ADDRESS_VALUE: 'address',
    CLICK_THROUGH: 'CLICK_THROUGH',
    VIEW_THROUGH: 'VIEW_THROUGH',
    ACTIVE: 'ACTIVE',
    PAUSED: 'PAUSED',
    VEHICLE: 'VEHICLE',
    TRAVEL: 'TRAVEL',
    RETARGETING: 'Retargeting',
    OFFSITE_CONVERSIONS: 'OFFSITE_CONVERSIONS',
    VIDEO_VIEWS: 'VIDEO_VIEWS',
    VIDEO_VIEWS_VALUE: 'VideoViews',
    THRUPLAY: 'THRUPLAY',
    CONTENT_VIEW: 'CONTENT_VIEW',
    CANVAS: 'Canvas',
    CAROUSEL: 'Carousel',
    VIDEO: 'Video',
    CINEMAGRAPH: 'Cinemagraph',
    STILL: 'Still',
    CLIENT_NAME: 'ClientName',
    OFFSITE_CONVERSIONS_VALUE: 'offsite_conversion',
    LEARN_MORE: 'LEARN_MORE',
    PHOTO: 'Photo',
    ZIP: 'Zip',
    INCLUDE: 'include',
    EXCLUDE: 'exclude',
    DETAILED_INCLUDE: 'detailedInclude',
    DETAILED_EXCLUDE: 'detailedExclude',
    CANVAS_VALUE: 'canvas',
    COLLECTION_VALUE: 'collection',
    CAROUSEL_VALUE: 'carousel',
    CINEMAGRAPH_VALUE: 'cinemagraph',
    VIDEO_VALUE: 'video',
    STILL_VALUE: 'still'
  }
};



// WEBPACK FOOTER //
// ./src/screens/PackageBuilder/constants/constants.js